export default "__VITE_ASSET__85eef781__"